import type { VoidFunctionComponent } from 'react';
import { isOrgInFreeTier } from '../../../../helpers/subscriptions';
import { SubscriptionBannerUpgradeWithDetails } from './SubscriptionBannerUpgradeWithDetails';
import { Action, ResourceType, useHasPermission } from '../../../../shared/permissions';

const SubscriptionBannerReportPage:VoidFunctionComponent = () => {
  const hasPermission = useHasPermission();
  const hasAccessToBilling = hasPermission({
    action: Action.Edit,
    resourceType: ResourceType.OrganizationBillingSettings,
  });
  const shouldDisplayBanner = (
    hasAccessToBilling &&
    isOrgInFreeTier()
  );

  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <div className="animated fadeInDown delay-animation-long">
      <SubscriptionBannerUpgradeWithDetails />
    </div>
  );
};

export default SubscriptionBannerReportPage;
